// extracted by mini-css-extract-plugin
export default {"container":"AccessTemplateList_container__PnC-y","sectionHeading":"AccessTemplateList_sectionHeading__tv3RF","cardsWrapper":"AccessTemplateList_cardsWrapper__ousy0"};